module.exports = __webpack_public_path__ + "static/8-IMG-2753-261b208c3cb49b4652f8a13cf87282e2.jpg";